export default "__VITE_ASSET__CmoVedON__"